import React from 'react';
import { toast } from 'react-toastify';
import './ShareButtons.css';

// Enlaces de compartir directos (sin SDKs de redes sociales, per seccion 45
// del documento del cliente: "Evitar cargar SDKs pesados de redes sociales").
function ShareButtons({ title }) {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title || '');

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Enlace copiado.');
    } catch (error) {
      toast.error('No se pudo copiar el enlace.');
    }
  }

  return (
    <div className="share-buttons">
      <span className="share-buttons__label">Compartir</span>
      <button type="button" onClick={copyLink} aria-label="Copiar enlace">Copiar enlace</button>
      <a href={`https://wa.me/?text=${encodedTitle}%20${encodedUrl}`} target="_blank" rel="noreferrer">WhatsApp</a>
      <a href={`https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`} target="_blank" rel="noreferrer">Telegram</a>
      <a href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`} target="_blank" rel="noreferrer">X</a>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`} target="_blank" rel="noreferrer">Facebook</a>
      <a href={`mailto:?subject=${encodedTitle}&body=${encodedUrl}`}>Email</a>
    </div>
  );
}

export default ShareButtons;
